export const productType = {
	/**
	* Gets the programmatic name of the entire locale, with the language,
	*	country and variant separated by underbars. The Language is always lower case,
	*	and country is always upper case. If the language is missing,
	*	the string will begin with an underscore character.
	*	If both the language and country fields are missing,
	*	this function will return the empty string,
	*	even if the variant field is filled in (you cannot have a locale with just a variant--
	*	the variant must accompany a valid language or country code). Examples: "en"
	*
	*/
    en: {
        product_type:'Product Type',
        product_type_information:'Product Type Information',
        product_type_id:'Product Type Id',
        product_type_management:'Product Type Management',
        add_product_type:'Add Product Type',
        edit_product_type:'Edit Product Type',
        product_type_name:'Product Type Name',
        status:'Status'
    },

	ar: {
        product_type:'نوع المنتج',
        product_type_information:'معلومات نوع المنتج',
        product_type_id:'معرف نوع المنتج',
        product_type_management:'إدارة نوع المنتج',
        add_product_type:'أضف نوع المنتج',
        edit_product_type:'تحرير نوع المنتج',
        product_type_name:'اسم نوع المنتج',
        status:'الحالة'
    }
}
